import Corks from '@/app/[locale]/wallet/components/commons/Corks';
import {useTranslations} from 'next-intl';
import {Button} from 'src/components/design-system';
import Cork from 'src/components/icons/Cork';
import {Link} from '@/i18n/routing';
import React from 'react';

interface Props {
  missingLoyaltyPoints: number;
}

const MissingLoyaltyPoints: React.FC<Props> = (props) => {
  const t = useTranslations('loyalty');

  return (
    <div className="flex flex-col gap-2">
      <div className="text-base text-center border p-4 rounded-lg text-gray-500">
        {t.rich('prizeDetail.missingLoyaltyPoints', {
          cork: () => (
            <Corks
              loyaltyPoints={props.missingLoyaltyPoints}
              numberSize="base"
              corkSize="4"
              corkColor="gray-500"
              numberColor="gray-500"
            />
          ),
        })}
      </div>
      <Link href={{pathname: '/wallet', hash: 'referral'}}>
        <Button type="link" size="lg" className="text-xl w-full">
          {t.rich('prizeDetail.inviteAFriend', {
            cork: () => <Cork />,
          })}
        </Button>
      </Link>
    </div>
  );
};

export default MissingLoyaltyPoints;
